import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";
import { Worker } from "../models/Worker";

export class WorkersRepository {
	private axios: Axios;

	constructor() {
		this.axios = axiosInstance;

		this.getWorkers = this.getWorkers.bind(this);
		this.getWorkerData = this.getWorkerData.bind(this);
		this.createWorker = this.createWorker.bind(this);
		this.updateWorker = this.updateWorker.bind(this);
		this.deleteWorker = this.deleteWorker.bind(this);
	}

	async getWorkers() {
		try {
			const resp = await this.axios.get("/worker");

			return {
				ok: true,
				data: resp,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}
	async getWorkerData(workerId: number | null) {
		try {
			const resp = await this.axios.get(`/worker/${workerId}`);

			return {
				ok: true,
				data: resp,
			};
		} catch (e: any) {
			return { ok: false, message: e.toString() };
		}
	}

	async updateWorker(workerId: number | null, data: any) {
		try {
			const resp = await this.axios.patch(`/worker/${workerId}`, data);
			return {
				ok: true,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}

	async createWorker(workerData: Worker) {
		try {
			const resp = await this.axios.post("/worker/", {
				workerName: workerData.workerName,
				workerTypeId:
					workerData?.workerTypeId == 1 ? 301 : workerData.workerTypeId,
				isActive: workerData.isActive,
			});
			return {
				ok: true,
				data: resp.data,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}

	async deleteWorker(workerId: number | null) {
		try {
			const resp = await this.axios.delete("/worker/", {
				params: { workerId },
			});
			return {
				ok: true,
				resp,
			};
		} catch (error: any) {
			const message = getError(error);

			return Promise.reject(message);
		}
	}
}

export const {
	getWorkers,
	getWorkerData,
	createWorker,
	updateWorker,
	deleteWorker,
} = new WorkersRepository();
